import type { IButtonProps } from "@similarweb/ui-components";

import type { IProModal } from "pro-features/components/Modals/src/ProModal";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { modalArt } from "./KeywordGeneratorToolArt";
import {
    ButtonContainer,
    KeywordGeneratorToolPageModalBody,
    KeywordGeneratorToolPageModalContainer,
    KeywordGeneratorToolPageModalFooter,
    KeywordGeneratorToolPageModalHeader,
} from "./styledComponents";

const modalStyle = {
    customStyles: {
        content: {
            marginTop: "28vh",
            width: "400px",
            height: "240px",
            padding: "24px",
            boxSizing: "content-box",
        },
    },
} satisfies IProModal;

interface IKeywordGeneratorToolPageModalProps extends Pick<IProModal, "isOpen" | "onCloseClick"> {
    newlyCreatedGroup?: boolean;
    onStartOverClick?: IButtonProps["onClick"];
    onViewGroupClick?: IButtonProps["onClick"];
}

export const KeywordGeneratorToolPageModal = ({
    isOpen,
    onCloseClick,
    onViewGroupClick,
    onStartOverClick,
    newlyCreatedGroup,
}: IKeywordGeneratorToolPageModalProps) => {
    const translate = useTranslation();

    const headerText = newlyCreatedGroup
        ? "keyword.generator.tool.modal.header"
        : "keyword.generator.tool.modal.header.updated_group";

    return (
        <ProModal
            isOpen={isOpen}
            onCloseClick={onCloseClick}
            {...modalStyle}
            showCloseIcon={false}
        >
            <KeywordGeneratorToolPageModalContainer>
                <KeywordGeneratorToolPageModalHeader>{translate(headerText)}</KeywordGeneratorToolPageModalHeader>
                <KeywordGeneratorToolPageModalBody>{modalArt}</KeywordGeneratorToolPageModalBody>
                <KeywordGeneratorToolPageModalFooter>
                    {onViewGroupClick ? (
                        <ButtonContainer
                            onClick={onViewGroupClick}
                            type="primary"
                            label={translate("keyword.generator.tool.modal.viewgroup")}
                        />
                    ) : null}
                    <ButtonContainer
                        onClick={onStartOverClick}
                        type="flat"
                        label={translate("keyword.generator.tool.modal.startover")}
                    />
                </KeywordGeneratorToolPageModalFooter>
            </KeywordGeneratorToolPageModalContainer>
        </ProModal>
    );
};
